import React, { useState, memo, useEffect } from 'react';
import { isBrowser } from 'ws-scripts/modules/environment';
import { useLabels } from 'wsm-common-data';
import { ClosestDealerMarkup, LocationModal } from 'wsm-location-modal';
import PropTypes from 'prop-types';

import { useClosestAccounts } from '../hooks/invDataHooks';

const ClosestDealerWrapper = ({ isMobile }) => {
	const [isOpenModal, setOpenModal] = useState(false);
	const { payload } = useClosestAccounts();
	const labels = useLabels();

	useEffect(() => {
		const subscriber = window?.DDC?.pubsub?.subscribe(
			'location-modal/show-modal',
			() => {
				setOpenModal(true);
			}
		);

		return () => {
			subscriber?.unsubscribe();
		};
	}, []);

	const { data: closestDealers, appliedParams, prefs = {} } = payload || {};

	if (!isBrowser || !closestDealers?.length) {
		return <></>;
	}

	const closestDealer = closestDealers[0];
	const { postalCode } = appliedParams;

	const { showYourStore } = prefs;

	const onCloseModal = () => {
		setOpenModal(false);
	};

	const onOpenModal = () => {
		if (showYourStore === 'true') {
			// Open location modal
			setOpenModal((previous) => !previous);
			return;
		}

		window?.DDC?.pubsub?.publish('ws-inv-filters/show-filters-modal');
	};

	const modalTitle = labels.get('YOUR_LOCATION');

	const onChangeSelectedStore = () => {
		window?.DDC?.pubsub?.publish('location-modal/update-store');
	};

	const onChangeUserPostalCode = (input) => {
		window.DDC.InvData.setUserLocation({
			filterName: 'geoZip',
			filterValues: [input]
		});
	};

	return (
		<>
			{isMobile && (
				<ClosestDealerMarkup
					closestDealer={closestDealer}
					userPostalCode={postalCode}
					onClick={onOpenModal}
					showYourStore={showYourStore === 'true'}
					containerClassNames={[
						'd-flex',
						'flex-wrap',
						'align-items-center',
						'flex-gap-row-1-rem',
						'mb-4'
					]}
				/>
			)}
			<LocationModal
				userPostalCode={postalCode}
				title={modalTitle}
				onClose={onCloseModal}
				isOpen={isOpenModal}
				isMobile={isMobile}
				onChangeSelectedStore={onChangeSelectedStore}
				onChangeUserPostalCode={onChangeUserPostalCode}
				persistUserStore
			/>
		</>
	);
};

export default memo(ClosestDealerWrapper);

ClosestDealerWrapper.propTypes = {
	isMobile: PropTypes.bool.isRequired
};
